import { Box } from '@material-ui/core'
import { useState } from 'react'
import GameGlobals from '../Game/GameGlobals'
import StyledButton from '../lookAndFeel/StyledIconButton'

import LockOpenIcon from 'mdi-material-ui/LockOpen'
import LockOpenVariantIcon from 'mdi-material-ui/LockOpenVariant'
import PhysicsWorld from '../../logic/loop/PhysicsWorld'

export default function ViewportLock({ physicsWorld = undefined as (undefined | PhysicsWorld) }) {

	const [viewportLocked, setViewportLocked] = useState(GameGlobals.viewportFollow)

	return (
		<Box display="flex" gridGap="8px" color="white">
			<StyledButton
				color="inherit"
				$selected={viewportLocked}
				onClick={() => {
					if (physicsWorld && GameGlobals.selectedEntity) {
						if (!viewportLocked) {
							physicsWorld.canvas?.renderer.plugins.viewport.follow(GameGlobals.selectedEntity.graphics)
						} else {
							physicsWorld.canvas?.renderer.plugins.viewport.plugins.remove('follow')
						}
						setViewportLocked(!viewportLocked)
					}
				}}
			>
				<Box gridGap="8px" alignItems="center" display="flex">
					VIEWPORT
					{viewportLocked ? (
						<LockOpenIcon />
					) : (
						<LockOpenVariantIcon />
					)}
				</Box>
			</StyledButton>
		</Box>
	)
}
